export default `
  mutation getAvatarUploadUrl($filename: String!) {
    getAvatarUploadUrl(filename: $filename) {
      url
      key
      bucket
      region
    }
  }
`
